/* Share modal — surfaces the read-only public link + quick actions.
   Ported from the Claude design's ShareModal. */
import { useState } from 'react';
import { Ico } from './Icons';
import type { Portfolio } from '@/portal/api/types';

export function ShareModal({
  portfolio,
  onClose,
  onOpenLookbook,
  onPrint,
  onEnquiry,
}: {
  portfolio: Portfolio;
  onClose: () => void;
  onOpenLookbook: () => void;
  onPrint: () => void;
  onEnquiry: () => void;
}) {
  const [copied, setCopied] = useState(false);
  const link = portfolio.share_token
    ? `${location.origin}/shared/${portfolio.share_token}`
    : 'Publishing link…';

  const copy = () => {
    try {
      if (navigator.clipboard && portfolio.share_token) navigator.clipboard.writeText(link);
    } catch {
      /* ignore */
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <>
      <div className="pl-drawer-scrim" onClick={onClose} />
      <div className="pl-share-modal">
        <div className="pl-drawer-head">
          <h3>Share “{portfolio.title}”</h3>
          <button className="pl-x" onClick={onClose} aria-label="Close">
            <Ico.x width={20} height={20} />
          </button>
        </div>
        <div style={{ padding: '20px 24px' }}>
          <div className="pl-field">
            <label>Shareable link (read-only client view)</label>
            <div style={{ display: 'flex', gap: 8 }}>
              <input readOnly value={link} style={{ fontSize: 12.5 }} onFocus={(e) => e.target.select()} />
              <button className="pl-btn" onClick={copy} disabled={!portfolio.share_token}>
                <Ico.link width={15} height={15} /> {copied ? 'Copied' : 'Copy'}
              </button>
            </div>
            <div style={{ fontSize: 12, color: 'var(--ink-faint)', marginTop: 6 }}>
              Anyone with the link sees a branded, read-only presentation — no login.
            </div>
          </div>
          <div style={{ display: 'grid', gap: 10, marginTop: 18 }}>
            <button className="pl-btn primary" style={{ justifyContent: 'flex-start' }} onClick={onOpenLookbook}>
              <Ico.share width={16} height={16} /> Preview the client view
            </button>
            <button className="pl-btn" style={{ justifyContent: 'flex-start' }} onClick={onPrint}>
              <Ico.download width={16} height={16} /> Export as PDF
            </button>
            <button className="pl-btn" style={{ justifyContent: 'flex-start' }} onClick={onEnquiry}>
              <Ico.mail width={16} height={16} /> Send to Didier's as enquiry
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
